import {
  BIDDING_DETAILS_DISABLE_LOADING,
  BIDDING_DETAILS_ENABLE_LOADING,
  ADD_BID_DISABLE_LOADING,
  BIDDING_DETAILS_LOADED,
  BIDDING_DETAILS_ERROR,
  BIDDING_RESET_FILTER,
  BIDDING_SET_ORIGIN_PORTS,
  ADD_BID_ENABLE_LOADING,
  ADD_BIDS_MORE_ENABLE_LOADING,
  ADD_BIDS_MORE_DISABLE_LOADING,
  BIDDING_SEND_ENABLE_LOADING,
  BIDDING_SEND_DISABLE_LOADING,
  BIDDING_DETAIL_RESET_FILTER,
  BIDDING_ACTIVITY_DISABLE_LOADING,
  BIDDING_ACTIVITY_LOADED,
  BIDDING_ACTIVITY_ENABLE_LOADING,
  LAST_QUOTE_DISABLE_LOADING,
  LAST_QUOTE_ENABLE_LOADING,
  SAVED_QUOTE_LOADED,
  LAST_QUOTE_LOADED,
  RESET_SAVED_QUOTE_DATA,
  SAVED_QUOTE_DISABLE_LOADING,
  RESET_LAST_QUOTE_DATA,
  SAVED_QUOTE_ENABLE_LOADING,
  ORIGIN_PORTS_DISABLE_LOADING,
  ORIGIN_PORTS_ENABLE_LOADING,
  BIDDING_DETAILS_UPDATE_FILTERS,
  ALL_BIDDING_DETAILS_LOADED,
  BID_ITEMS_SET_PAGINATION,
  BID_ITEMS_RESET_PAGINATION,
} from '../actions/constants';
import {
  getLastSortedColumnValue,
  getLastRFQBidItemColumnId,
} from '../utils/pagination';

const defaultState = {
  isLoading: true,
  errorMessage: null,
  biddingData: null,
  selectedFilters: {
    statuses: [],
    destinationPortIds: [],
    destinationPortList: [],
    bidCountFilter: 'ALL',
    originPortIds: [],
    containerSizeList: [],
    incoterms: [],
  },
  bidItemsPagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
    isNextPresent: true,
    resultPerPage: 100,
  },
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case BIDDING_DETAILS_UPDATE_FILTERS: {
      return {
        ...state,
        selectedFilters: Object.assign({}, state.selectedFilters, action.data),
      };
    }
    case SAVED_QUOTE_ENABLE_LOADING: {
      return {
        ...state,
        isSavedQuoteLoading: true,
      };
    }
    case SAVED_QUOTE_DISABLE_LOADING: {
      return {
        ...state,
        isSavedQuoteLoading: false,
      };
    }
    case SAVED_QUOTE_LOADED: {
      return {
        ...state,
        savedQuoteData: action.data,
      };
    }
    case RESET_SAVED_QUOTE_DATA: {
      return {
        ...state,
        savedQuoteData: null,
        isSavedQuoteLoading: false,
      };
    }
    case RESET_LAST_QUOTE_DATA: {
      return {
        ...state,
        isSentQuoteLoading: false,
        sentQuoteData: null,
      };
    }
    case ADD_BIDS_MORE_ENABLE_LOADING: {
      return {
        ...state,
        isAddMoreBidsLoading: true,
      };
    }
    case ADD_BIDS_MORE_DISABLE_LOADING: {
      return {
        ...state,
        isAddMoreBidsLoading: false,
      };
    }
    case ADD_BID_ENABLE_LOADING: {
      return {
        ...state,
        isAddBidLoading: true,
      };
    }
    case ADD_BID_DISABLE_LOADING: {
      return {
        ...state,
        isAddBidLoading: false,
      };
    }
    case ORIGIN_PORTS_ENABLE_LOADING: {
      return {
        ...state,
        isOriginPortLoading: true,
      };
    }
    case ORIGIN_PORTS_DISABLE_LOADING: {
      return {
        ...state,
        isOriginPortLoading: false,
      };
    }
    case BIDDING_SET_ORIGIN_PORTS: {
      return {
        ...state,
        originPorts: action.data,
      };
    }
    case BIDDING_SEND_ENABLE_LOADING: {
      return {
        ...state,
        isSendResponseLoading: true,
      };
    }
    case BIDDING_SEND_DISABLE_LOADING: {
      return {
        ...state,
        isSendResponseLoading: false,
      };
    }
    case LAST_QUOTE_ENABLE_LOADING: {
      return {
        ...state,
        isSentQuoteLoading: true,
      };
    }
    case LAST_QUOTE_DISABLE_LOADING: {
      return {
        ...state,
        isSentQuoteLoading: false,
      };
    }
    case LAST_QUOTE_LOADED: {
      return {
        ...state,
        sentQuoteData: action.data,
      };
    }
    case BIDDING_ACTIVITY_ENABLE_LOADING: {
      return {
        ...state,
        isActivityLoading: true,
      };
    }
    case BIDDING_ACTIVITY_DISABLE_LOADING: {
      return {
        ...state,
        isActivityLoading: false,
      };
    }
    case BIDDING_ACTIVITY_LOADED: {
      return {
        ...state,
        activityData: action.data,
      };
    }
    case BIDDING_DETAILS_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case BIDDING_DETAILS_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case BIDDING_DETAILS_LOADED: {
      return {
        ...state,
        errorMessage: null,
        biddingData: action.data,
        bidItemsPagination: {
          ...state.bidItemsPagination,
          currentPageNumber: action.data.currentPageNumber ||
          state.bidItemsPagination.currentPageNumber,
          isNextPresent: action.data.isNextPresent,
          lastSortedColumnValueNext: action.data.lastSortedColumnValueNext,
          lastItemIdNext: action.data.lastItemIdNext,
          lastSortedColumnValuePrev: action.data.lastSortedColumnValuePrev,
          lastItemIdPrev: action.data.lastItemIdPrev,
          lastSortedColumnValue: getLastSortedColumnValue(action.data),
          lastRowId: getLastRFQBidItemColumnId(action.data),
        },
      };
    }
    case ALL_BIDDING_DETAILS_LOADED: {
      return {
        ...state,
        errorMessage: null,
        allBiddingData: action.data,
      };
    }
    case BIDDING_DETAILS_ERROR: {
      return {
        ...state,
        biddingData: null,
        errorMessage: action.errorMessage,
      };
    }
    case BIDDING_DETAIL_RESET_FILTER: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters,
      };
    }
    case BID_ITEMS_SET_PAGINATION: {
      return {
        ...state,
        bidItemsPagination: {
          ...state.bidItemsPagination,
          ...action.data,
        },
      };
    }

    case BID_ITEMS_RESET_PAGINATION: {
      return {
        ...state,
        bidItemsPagination: {
          ...defaultState.bidItemsPagination,
          resultPerPage: state.bidItemsPagination.resultPerPage,
        },
      };
    }
    default: return state;
  }
}
